import styled from 'styled-components';

export const Header = styled.h1<{ isGameActive: boolean }>`
  margin: ${(props) =>
    props.isGameActive ? '1rem 0 2rem 0' : '0.5rem 0 0.75rem 0'};
  font-size: ${(props) => (props.isGameActive ? '2.5em' : '1em')};
  text-align: center;
`;

export const Container = styled.section`
  max-width: 960px;
  margin-inline: auto;
  padding: 1rem;
`;

export const FormItem = styled.div`
  label {
    font-size: 1.25rem;
  }

  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  width: 100%;
`;

export const FormTitle = styled.div`
  font-size: 1.25rem;
`;

export const FlexItem = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 1rem;

  button {
    max-width: fit-content;
    flex-wrap: nowrap;
    display: grid;
    place-items: center;
    padding: 0.5rem;

    img {
      width: 22px;
      height: 22px;
    }
  }
`;

export const ActionsGameContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding-top: 3rem;
  border-radius: 0.5rem;
  max-width: 400px;
  margin: 0 auto;

  button {
    width: fit-content;
  }
`;

export const PlayerItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  > h4 {
    margin: 0.5rem !important;
  }

  span {
    display: inline-flex;
    gap: 0.5rem;
    align-items: center;
  }
`;

export const SwitcherContainer = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const HiddenRadio = styled.input.attrs({ type: 'checkbox' })`
  display: none;
`;

export const Switcher = styled.label<{ isActive: boolean }>`
  width: 50px;
  height: 25px;
  background-color: ${({ isActive }) => (isActive ? 'green' : 'grey')};
  border-radius: 15px;
  cursor: pointer;
  position: relative;
  transition: background-color 0.3s ease;

  &:before {
    content: '';
    width: 20px;
    height: 20px;
    background: white;
    border-radius: 50%;
    position: absolute;
    top: 2.5px;
    left: ${({ isActive }) => (isActive ? 'calc(100% - 22.5px)' : '2.5px')};
    transition: left 0.3s ease;
  }
`;

export const ShopLink = styled.a`
  color: #0070f3;
  text-decoration: underline;
  transition: color 0.2s ease;

  &:hover {
    color: #0051a3;
  }
`;

export const ShopNote = styled.p`
  text-align: center;
  font-size: 0.9rem;
  color: #666;
  margin-top: 1.5rem;
`;

export const Expandable = styled.div<{ expanded: boolean; height: number }>`
  overflow: hidden;
  transition:
    height 0.3s ease,
    opacity 0.3s ease;
  height: ${({ expanded, height }) => (expanded ? `${height}px` : '0px')};
  opacity: ${({ expanded }) => (expanded ? 1 : 0)};
  pointer-events: ${({ expanded }) => (expanded ? 'auto' : 'none')};
`;
